import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { validateSession } from 'store/ui/actions'

const POLL_INTERVAL_MS = 60000

//
// Polls `/users/me` once a minute for signed-in users so the "one session at a
// time" limit can log the loser out (see `validateSession` in store/ui/sagas).
//
// This used to live inside the top-nav alerts dropdown, which was an accident of
// history — it had nothing to do with notifications. SCI-4296 dropped that
// dropdown, so the poll now hangs off NavButtons instead, which renders in the
// same places the dropdown did.
//
const useSessionValidation = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const user = useSelector(({ ui }) => ui.user)

  useEffect(() => {
    if (!user?.email) return
    const intervalId = setInterval(() => {
      dispatch(validateSession({ history, user }))
    }, POLL_INTERVAL_MS)
    return () => clearInterval(intervalId)
  }, [user, dispatch, history])
}

export default useSessionValidation
